import HBMessage from "@/components/HBMessage";
import HBConfirm from "@/components/HBModal/confirm";
import HBInfoDialog from "@/components/HBModal/info";
import { destroyAll } from "@/components/HBModal/ModalWrap";
import { resetVerify } from "@/services";
import { openUdesk } from "@/utils/initUdesk";
import dayjs from "dayjs";
import Router from "next/router";
import styles from "../index.module.less";

export default function accountLocked(result) {
  if (result.msg && !result.errReason) {
    accountReset(result);
    return;
  }

  let HBInfoDialogIns;
  let infoProps = {
    title: "提示",
    content: null,
  };

  const jiedong = () => {
    HBInfoDialogIns.destroy();
    Router.push("/appeal");
    destroyAll();
  };

  // 封禁时间大于100年为永久封禁，依旧使用原来的提醒逻辑， 当前后端永久封禁时间为200年
  if (
    result?.banUntil &&
    result.banUntil - Date.now() < 1000 * 3600 * 24 * 365 * 100
  ) {
    infoProps.content = (
      <div className={styles.loginInfo}>
        <p>
          因系统检测到您的账号近期有违反《花瓣用户协议》的行为，已自动对账号进行了临时冻结，将在
          <span className="color-primary">
            {dayjs(result.banUntil).format("YYYY/MM/DD HH:mm")}
          </span>
          解冻。
        </p>
        <p>账号异常可能是因为：{result.errReason}</p>
      </div>
    );
  } else if (~result?.errReason?.indexOf("疑似盗号")) {
    infoProps.content = (
      <div className={styles.loginInfo}>
        您的账号最近有异常登录行为，被临时冻结。重置密码后，账号可恢复正常。
      </div>
    );
    infoProps.hideCancelBtn = true;
  } else if (~result?.errReason?.indexOf("用户主动注销")) {
    infoProps.content = (
      <div className={styles.loginInfo}>
        当前账号已主动注销或存在异常行为，不可登录/注册。
      </div>
    );
    infoProps.hideOkBtn = true;
  } else if (~result?.errReason?.indexOf("login limit")) {
    infoProps.content = (
      <div className={styles.loginInfo}>
        您的账号有异常登录行为，为了保障账号安全，请重新设置账号密码。
      </div>
    );
    infoProps.hideCancelBtn = true;
  } else if (~result?.errReason?.indexOf("系统自动禁止")) {
    infoProps.content = (
      <div className={styles.loginInfo}>
        <p>
          您的花瓣账号最近发布了违规内容，为了保障账号安全，您的账号已被临时冻结。
        </p>
        <p>账号异常可能是因为：发布违规内容</p>
      </div>
    );
  } else {
    infoProps.content = (
      <div className={styles.loginInfo}>
        <p>您的花瓣账号最近有异常行为，为了保障账号安全，您的账号已被冻结.</p>
        <p>账号异常可能是因为：{result.errReason}</p>
      </div>
    );
  }
  infoProps = {
    ...infoProps,
    okText: "解冻申诉",
    cancelText: "联系客服",
    cancelButtonProps: {
      onClick: openUdesk,
    },
    onOk: jiedong,
  };

  HBInfoDialogIns = HBInfoDialog.open(infoProps);
}

// 账号需要重置
function accountReset(result) {
  if (result.msg.includes("重新设置账号密码")) {
    // 只有带有邮箱账号会触发此类问题，需要通过发送重置密码的邮件进行重置密码
    // 从返回的msg中获取邮箱信息
    const email = result.msg.match(/\$\$reset_email:(\S+)/)[1];
    HBInfoDialog.open({
      title: "提示",
      okText: "发送邮件",
      onOk: async () => {
        const result = await resetVerify({
          email: email,
        });

        if (result.error || result.err) {
          HBMessage.error(result.error || result.msg || "发送失败");
          return;
        }

        HBConfirm.open({
          type: "success",
          title: "提示",
          content: `重置密码的链接已被发送到你的邮箱${email}，请去往邮箱查看邮件进行重置密码。`,
          okText: "确认",
        });
      },
      content: (
        <div className={styles.loginInfo}>
          <p>
            您的花瓣账号有异常登录行为，为了保障账号安全，请重新设置账号密码。系统将向您的登录邮箱
            {email}发送重置密码邮件。
          </p>
        </div>
      ),
    });
  } else {
    HBInfoDialog.open({
      title: "提示",
      hideOkBtn: true,
      content: (
        <div className={styles.loginInfo}>
          <p>{result.msg}</p>
        </div>
      ),
    });
  }
}
